import IStepFourModel from './IStepFourModel';

const StepFourModelInitialState: IStepFourModel = {
  estelamBimehMarkaziOption: null,
};

export default StepFourModelInitialState;
